import ScrollReveal from "./ScrollReveal";

const workBest = [
  "Have a real problem they've experienced firsthand",
  "Are ready to move, not still \"exploring\"",
  "Value speed and clarity over process theater",
  "Understand that building means making hard choices",
  "Want a partner, not a vendor",
];

const dontWork = [
  "Want a pitch deck, not a product",
  "Need six meetings before making a decision",
  "Think AI is a magic wand, not a tool",
  "Are looking for the cheapest option",
  "Aren't willing to do the work alongside me",
];

export default function WhoIWorkWith() {
  return (
    <section id="who-i-work-with" aria-label="Who I Work With" className="bg-surface">
      <div className="editorial-container section-spacing">
        {/* Label */}
        <ScrollReveal>
          <p className="font-mono text-label uppercase tracking-[0.05em] text-accent">
            WHO I WORK WITH
          </p>
        </ScrollReveal>

        {/* Headline */}
        <ScrollReveal stagger={1}>
          <h2 className="mt-6 font-display text-section font-bold text-foreground md:text-section-md lg:text-section-lg">
            Who I Work With
          </h2>
        </ScrollReveal>

        {/* Two-column comparison */}
        <ScrollReveal stagger={2} className="mt-12">
          <div className="grid gap-12 md:grid-cols-2 md:gap-16">
            {/* Best fit */}
            <div>
              <h3 className="font-display text-subsection font-semibold text-foreground md:text-subsection-md">
                I work best with founders who:
              </h3>
              <ul className="mt-6 space-y-3">
                {workBest.map((item) => (
                  <li key={item} className="flex items-start gap-3">
                    <span
                      aria-hidden="true"
                      className="mt-0.5 shrink-0 text-accent"
                    >
                      ✓
                    </span>
                    <span className="text-foreground-muted">{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Not a fit */}
            <div>
              <h3 className="font-display text-subsection font-semibold text-foreground md:text-subsection-md">
                I don&rsquo;t work with founders who:
              </h3>
              <ul className="mt-6 space-y-3">
                {dontWork.map((item) => (
                  <li key={item} className="flex items-start gap-3">
                    <span
                      aria-hidden="true"
                      className="mt-0.5 shrink-0 text-foreground-faint"
                    >
                      ✗
                    </span>
                    <span className="text-foreground-faint">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </ScrollReveal>

        {/* Footer callout */}
        <ScrollReveal className="mt-16">
          <div className="border-l-2 border-accent bg-accent-subtle py-4 pl-6">
            <p className="text-body-lg font-medium text-foreground md:text-body-lg-md">
              If you want honesty, speed, and systems that actually work,
              let&rsquo;s build.
            </p>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}
